import { observer } from "mobx-react";
import { autorun } from "mobx";
import { useEffect } from "react";
import OverrideDefaults from "../SandboxViewerComponent/src/widgets/Filter/OverrideDefaults";

const LevelOverrideUpdater = ({ CommunicationStore, Level }) => {
  useEffect(() => {
    // Use autorun instead of observer() so MobX drives the reactive logic
    // directly, without calling React's forceUpdate on this component.
    // Prevents "update LevelOverrideUpdater while rendering URLParameterController"
    // in React 18 concurrent mode.
    const dispose = autorun(() => {
      let value = null;
      const accessor = CommunicationStore.getMessagesToID({
        to: "filterAccess",
      })?.message(Level);
      if (accessor) {
        const { items, index } = accessor;
        if (
          items !== undefined &&
          index !== undefined &&
          index !== null &&
          items?.length &&
          index !== -1
        ) {
          value = items[index].label;
        }
      }
      if (value) {
        // console.warn(`Update ${Level} Value`, value);
        OverrideDefaults[Level] = value;
      }
    });
    return dispose;
  }, [CommunicationStore, Level]);

  return <div style={{ display: "none" }} />;
};

const OverrideUpdater = ({
  CommunicationStore,
  Levels = ["Szenario", "Characteristic"],
}) => {
  return (
    <div
      style={{
        background: "transparent",
        position: "absolute",
        top: 0,
        left: 0,
        height: 0,
        width: 0,
        color: "transparent",
        pointerEvents: "none",
      }}
    >
      {Levels.map((level) => {
        return (
          <LevelOverrideUpdater
            CommunicationStore={CommunicationStore}
            Level={level}
            key={level}
          />
        );
      })}
    </div>
  );
};

export default observer(OverrideUpdater);
